/**
 * スマホ表示の際、絞り込みボタンをある一定ライン超えたら表示
 * requestAnimationFrameを利用したthrottle(スクロールイベントの間引き)で実装
 */

document.addEventListener("DOMContentLoaded", () => {
  let last_known_scroll_position = 0;
  let ticking = false;
  const scrollFilter = document.getElementById("js-scrollFilter");

  function doClassAdd(scroll_pos) {
    if (scrollFilter) {
      // スクロール位置で何かをする
      if (scroll_pos > 180) {
        scrollFilter.classList.add("is-active");
      } else {
        scrollFilter.classList.remove("is-active");
      }
    }
  }

  window.addEventListener("scroll", function (e) {
    last_known_scroll_position = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        doClassAdd(last_known_scroll_position);
        ticking = false;
      });
      ticking = true;
    }
  });
});
